import { getDefaultPath } from '../../helpers/urlSync';

const options = [
	{
		label: "sidebar.dashboard",
		key: "",
		leftIcon: "library_books",
		hideBreadCrumb: true
	},
	{
		label: "sidebar.propertymanagement",
		key: "premium",
		leftIcon: "home",
		hideBreadCrumb: true
	},
	{
		label: "sidebar.messages",
		key: "messages",
		leftIcon: "email",
		hideBreadCrumb: true
	},
	{
		label: "sidebar.properties",
		leftIcon: "web",
		key: "properties",
		children: [
			{
				label: "sidebar.myProperties",
				key: "myproperties",
				hideBreadCrumb: true
			},
			{
				label: "sidebar.addProperty",
				key: "addproperty",
				hideBreadCrumb: true
			},
			// {
			// 	label: "My Property Listings",
			// 	key: "property-listings",
			// 	hideBreadCrumb: true
			// },
			{
				label: "sidebar.viewings",
				key: "viewings",
				hideBreadCrumb: true
			}
		]
	},
	{
		label: "sidebar.tenants",
		leftIcon: "supervisor_account",
		key: "tenants",
		children: [
			{
				label: "sidebar.currentTenants",
				key: "currenttenants",
				hideBreadCrumb: true
			},
			{
				label: "sidebar.tenantReferencing",
				key: "tenantreferencing",
				hideBreadCrumb: true
			},
			{
				label:"sidebar.referenceRequests",
				key:"outstandingreferences",
				hideBreadCrumb: true
			}
		]
	},
	{
		label: "sidebar.rentVerifications",
		key: "rentverifications",
		leftIcon: "list_alt",
		hideBreadCrumb: true
  },
  {
		label: "sidebar.issues",
		key: "issues",
		leftIcon: "list_alt",
	  	hideBreadCrumb: true
	},
];

const getBreadcrumbOption = () => {
	const preKeys = getDefaultPath();
	let parent, activeChildren;
	options.forEach(option => {
		if (preKeys[option.key]) {
			parent = option;
			(option.children || []).forEach(child => {
				if (preKeys[child.key]) {
					activeChildren = child;
				}
			});
		}
	});
	return { parent, activeChildren };
};
export default options;
export { getBreadcrumbOption };



// WEBPACK FOOTER //
// ./src/containers/Sidebar/options.js